import React from 'react';
import { useParams } from 'react-router-dom';
import { WEB_APP_ORIGIN } from '../storeConfig';
import DeepLinkShell from '../DeepLinkShell';
import SmartAppCta from '../SmartAppCta';

const PromoLanderPage: React.FC = () => {
  const { code } = useParams<{ code: string }>();

  return (
    <DeepLinkShell>
      <div className="dl-card">
        <h1 className="dl-name">Special offer</h1>
        <p className="dl-meta">Use this promo code in LookBel when you book:</p>
        <p className="dl-code">{code || '—'}</p>
        <SmartAppCta
          title="Redeem in the app"
          subtitle="Open LookBel and apply the code at checkout."
          webHref={`${WEB_APP_ORIGIN}/`}
          webLabel="Visit LookBel on the web"
        />
      </div>
    </DeepLinkShell>
  );
};

export default PromoLanderPage;
